import { render } from "./WpeActions.vue?vue&type=template&id=66c83812"
import script from "./WpeActions.vue?vue&type=script&lang=js"
export * from "./WpeActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/templates/WpeActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66c83812"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66c83812', __exports__)) {
    api.reload('66c83812', __exports__)
  }
  
  module.hot.accept("./WpeActions.vue?vue&type=template&id=66c83812", () => {
    api.rerender('66c83812', render)
  })

}


export default __exports__